import Modal from '../../../../components/Modal'
import Button from '../../../../components/ButtonNew'
import * as alertLoader from '../../../../assets/animations/alert.json'
import Lottie from 'react-lottie'
import Text from '../../../../components/Text'
const VerifyError = ({ onClose, onRetry, data = {}, isOpen = false }) => {
  const alertLoaderOption = {
    loop: true,
    autoplay: true,
    animationData: alertLoader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <Modal isOpen={isOpen} fullScreen showCloseBtn={false} onClose={onClose}>
      <div className="h-[90vh] flex flex-col justify-center items-center">
        <div>
          <Lottie
            options={alertLoaderOption}
            height={120}
            width={120}
            className="mx-auto"
          />
        </div>
        <div className="space-y-4 px-4">
          <Text
            tag="h1"
            variant="headline"
            size="medium"
            textalign="center"
            className="text-[#1F2933]"
          >
            {data?.title || 'Verification Failed'}
          </Text>
          <Text
            tag="p"
            variant="body"
            size="large"
            textalign="center"
            className="text-[#5A6774]"
          >
            {data?.subtitle || 'Please try again'}
          </Text>
        </div>
        <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full bg-white">
          <div className="grid grid-cols-2 gap-4">
            <Button fullWidth onClick={onClose} variant="outlined">
              Cancel
            </Button>
            <Button fullWidth onClick={onRetry}>
              Retry
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default VerifyError
